module.exports = __webpack_public_path__ + "static/media/laptop.303f884f.png";